
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-revigres",
      function () {
        return require("private-next-pages/my-revigres/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-revigres"])
      });
    }
  